const sortOptions = { sensitivity: "base" };

export const normalizeStateOptions = (statesList = []) => {
  const seen = new Set();
  const normalized = [];

  (statesList || []).forEach((state) => {
    const name = (state?.name || "").trim();
    if (!name) return;
    const key = name.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    normalized.push(name);
  });

  return normalized.sort((a, b) => a.localeCompare(b, "en", sortOptions));
};

export default normalizeStateOptions;
